//--general
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


import 'bootstrap';
import 'bootstrap-select';
import { openTab, openTab2 } from './parts/tabs.js';
import 'slick-carousel';
import { carousels } from './parts/carousels';
import { accordion } from './parts/accordion';
import 'magnific-popup';
import { gallery } from './parts/gallery';
import './plugins/jquery-zend-jsonrpc';
import { setupComments, setupNewComment, setupCommentLike, userGameFavorite } from './parts/api';
import 'raty-js';
import { raty } from './parts/raty';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import 'jquery-match-height';


(function ($) {

    //-- delay function for resizing
    var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();

    $(document).ready(function(){
		setupComments();
		setupNewComment();
		setupCommentLike();
		userGameFavorite();

        //tabs
        $('.tablinks').click(function (event) {
            let tab = $(this).data('tab');

            openTab(event, tab);
        })

        $('.tablinks2').click(function (event) {
            let tab = $(this).data('tab');

            openTab2(event, tab);
        })

        if ($('#profil-menu').length > 0) {
            $(".tablinks[data-tab='Komentarze']").click()
        }

        $('#profil-menu').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            let tab = $(this).find("option")[clickedIndex].value;
            $(".tablinks[data-tab='"+tab+"']").click()
        });

        $('.bootstrap-select--checkboxes').on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {

            //new SimpleBar([0]);

            //.each(element, new SimpleBar());
            new SimpleBar($(this).parent('.bootstrap-select--checkboxes').find(".dropdown-menu.inner.show")[0], { autoHide: false });
        });

        $("#mobile-nav").click(function(){
            $("body").toggleClass("menu-opened")
        })

        //$('.game .game__name-box .name').matchHeight();


        $("#defaultOpenTab").click();
        $("#defaultOpenTab2").click();

        carousels();

        gallery();
        accordion();
        raty();

        $("a").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
    
            // Store hash
            var hash = this.hash;
    
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
            scrollTop: $(hash).offset().top
            }, 800, function(){
    
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
            });
        } // End if
        });

		$('.promo-code').click(function() {
			if (window['promo-copy-timeout']) {
				clearTimeout(window['promo-copy-timeout']);
				$('.promo-code__copied').hide();
				$('.promo-code__content').removeClass('hide');				
			}
			
			var code = $(this).data('code');
			
			var temp = document.createElement('input');
			temp.style.position = 'absolute';
			temp.style.left = '-1000px';
			temp.style.top = '-1000px';
			temp.type = 'text';
			temp.setAttribute('value', code);
			document.body.appendChild(temp);
			
			temp.select();
			
			try {
				document.execCommand('copy');
			} catch (ex) {}
			
			$(temp).remove();
			
			$('.promo-code__copied').show();
			$('.promo-code__content').addClass('hide');
			
			window['promo-copy-timeout'] = setTimeout(function() {
				$('.promo-code__copied').hide();
				$('.promo-code__content').removeClass('hide');
			}, 1000);
		})

    });


    $(window).on({
        load:function(){

        },
        resize:function(){

        },
        scroll:function(){

       }
    });

}(jQuery));